<template>
  <div>
    <v-row>
      <v-col>
        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
          slider-color="#ffbc00">
          <v-tab class="font-weight-black">Tipos de Licencia</v-tab>
          <v-tab class="font-weight-black">Licencias</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item class="py-4">
            <licenciaTipo />
          </v-tab-item>
          <v-tab-item class="py-4">
            <licencia />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LicenciaTipo from './components/LicenciaTipoComp.vue'
import Licencia from './components/LicenciaComp.vue'


export default {
  data() {
    return {
      tab: 0
    }
  },
  components: {
    licenciaTipo: LicenciaTipo,
    licencia: Licencia

  },
}
</script>

